import * as React from "react";
import { store } from '../../../store/index';
import { IInitialState, DataContext, TicketMessageDTO, TicketStatus, TicketResponseMessageSender, TicketResponseType, WebChatStatus } from '../../../models/chat.models';
import { webChatService } from '../../../services/webchat.service';
import Prompt from '../prompts/prompt';
import ConversationMessage from "./conversation-message";

var Color = require('color');

export interface WebChatConversationProps { }

export const WebChatConversation = (props: WebChatConversationProps) => {
  let context: IInitialState = React.useContext(DataContext);
  const myConversationContainerRef = React.useRef(null);
  const [conversationContainerHeight, setConversationContainerHeight] = React.useState(context.webchatHeight);
  const [lastElementRef, setLastElementRef] = React.useState(null);
  const [buttonCloseDisable, setButtonCloseDisable] = React.useState(false);
  const [buttonContinueDisable, setButtonContinueDisable] = React.useState(false);

  const HEADER_HEIGHT: number = 160;
  const FOOTER_HEIGHT: number = 56; 

  const cssContent = require('./conversation.css').toString();
  let personalizedCss = '';

  if (context.webChatSettings && context.webChatSettings.MainColour) {
    const mainColor = Color(context.webChatSettings.MainColour).rgb().string();
    const lighthenMainColor = Color(context.webChatSettings.MainColour).lighten(0.2).rgb().string();
    const lighthen2MainColor = Color(context.webChatSettings.MainColour).lighten(0.3).rgb().string();
    
    personalizedCss = '\
    .help-desk-comment-customer, .help-desk-close-button, .help-desk-continue-button {\
      background: linear-gradient(135deg, ' + mainColor + ' 0%, ' + lighthenMainColor + ' 100%); \
    }\
    .help-desk-close-button:hover, .help-desk-continue-button:hover {\
      background: linear-gradient(135deg, ' + lighthenMainColor + ' 0%, ' + lighthen2MainColor + ' 100%); \
    }\
    .help-desk-avatar-image-bg-colour{\
      background: linear-gradient(135deg, ' + lighthenMainColor + ' 0%, ' + lighthen2MainColor + ' 100%); \
    }\
    ';
  }

  if (context.webChatSettings && context.webChatSettings.PrimaryTextColour) {

    const alphaPrimaryTextColour = Color(context.webChatSettings.PrimaryTextColour).alpha(0.7).rgb().string();

    personalizedCss = personalizedCss + '\
    .help-desk-comment-support {\
      color: ' + context.webChatSettings.PrimaryTextColour + ';\
    }\
    .help-desk-composer textarea::placeholder {\
      color: ' + alphaPrimaryTextColour + ';\
    }';
  }

  if (context.webChatSettings && context.webChatSettings.SecondaryTextColour) {
    
    personalizedCss = personalizedCss + '\
    .help-desk-comment-customer, .help-desk-close-button, .help-desk-continue-button {\
      color: ' + context.webChatSettings.SecondaryTextColour + '; \
    }';
  }
  
  async function closeWebChat(close: boolean) {
    if (context.webChatDto && context.webChatDto.Session) {
      setButtonCloseDisable(true);
      setButtonContinueDisable(true);
      setTimeout(async function() {
        try {
          //let result = await webChatService.closeWebchat({ closeWebChat: close, session: context.webChatDto.session });
          
          //if (result) {
          //  if (result.status == WebChatStatus.Closed) {
          //    Cookies.remove("wch_session");
          //  }
          //  store.dispatch({ type: 'SET_WEB_CHAT', payload: result });
          //}
        } catch(ex) {
        } finally {
          setButtonCloseDisable(false);
          setButtonContinueDisable(false);
        }
      }, 0);
    }
  }

  function getShortName(fileUrl: string): string {
    const delimited: string[] = fileUrl.split("/");
    return delimited[delimited.length - 1];
  }

  let closureButtons = <div className="help-desk-conversation-message">
      <div className="help-desk-conversation-message-left">
        <div className="help-desk-avatar-message">
          <div className="help-desk-avatar-image help-desk-avatar-image-bg-colour">
            <img className="invert-middle" src={`${context.webChatSettings.AssistantIconUrl}`} alt="Agent profile" />
          </div>
        </div><div className="help-desk-comment help-desk-comment-support">
          <div className="help-desk-close-webchat-content">
            <button disabled={buttonCloseDisable} className="help-desk-close-button button-margin" onClick={() => {  closeWebChat(true); }}>
              <div className="help-desk-close-button-content">
                <span>
                  {webChatService.getTranslations(18, context.webChatSettings)}
                </span>
              </div>
            </button>
            <button disabled={buttonContinueDisable} className="help-desk-continue-button button-margin" onClick={() => {  closeWebChat(false); }}>
              <div className="help-desk-continue-button-content">
                <span>
                  {webChatService.getTranslations(6, context.webChatSettings)}
                </span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  
  function isSupportAgent(message: TicketMessageDTO): boolean{
    return message.MessageSenderType == TicketResponseMessageSender.HelpDesk 
      || message.MessageSenderType == TicketResponseMessageSender.System 
      || message.MessageSenderType == TicketResponseMessageSender.Internal;
  }

  function isCustomer(message: TicketMessageDTO): boolean {
    return message.MessageSenderType == TicketResponseMessageSender.Customer 
    || message.MessageSenderType == TicketResponseMessageSender.Anonymous;
  }

  React.useEffect(() => {
    if (myConversationContainerRef && myConversationContainerRef.current) {
      if (conversationContainerHeight != myConversationContainerRef.current.scrollHeight + HEADER_HEIGHT + FOOTER_HEIGHT) {
        setConversationContainerHeight(myConversationContainerRef.current.scrollHeight + HEADER_HEIGHT + FOOTER_HEIGHT);
        store.dispatch({ type: 'SET_WEBCHAT_HEIGHT', payload: myConversationContainerRef.current.scrollHeight + HEADER_HEIGHT + FOOTER_HEIGHT});   
      }
    }
    if (lastElementRef && lastElementRef.scrollIntoView) {
      setTimeout(function() {
        lastElementRef.scrollIntoView({behavior: "smooth", block: "end"});
      }, 200);
    }
  });

  return (
    <div className="help-desk-conversation-body">
      <style>
        {cssContent}
        {personalizedCss}
      </style>
      <div className="help-desk-conversation-body-parts" aria-live="assertive" aria-atomic="false" role="alert" style={{bottom: context.messageHeight}}>
        <div className="help-desk-conversation-body-parts-wrapper">
          <div ref={myConversationContainerRef} className="help-desk-conversation-content help-desk-conversation-transfrom" style={{ transform: "translateY(0px)" }}>
            
            {context.welcomeMessage && <div className="help-desk-conversation-message">
              <div className="help-desk-conversation-message-left">
                <div className="help-desk-avatar-message">
                  <div className="help-desk-avatar-image help-desk-avatar-image-bg-colour">
                    <img className="invert-middle" src={`${context.webChatSettings.AssistantIconUrl}`} alt="Agent profile" />
                  </div>
                </div>
                <div className="help-desk-comment help-desk-comment-support">
                  <div className="help-desk-block-paragraphs">
                    <div className="help-desk-block-paragraph help-desk-block-paragraph-support"><br />{webChatService.getTranslations(10, context.webChatSettings)}</div>
                  </div>
                  
                </div>
              </div>
            </div>}
            <div className="help-desk-prompt-container">
                  {
                      context.webChatSettings.InitialPrompts && context.webChatSettings.InitialPrompts.map((prompt, index) => {
                        return <Prompt className="help-desk-prompt-button" key={index} title={prompt.Title} prompt={prompt.Prompt} />
                      })
                  }
            </div>
            {(context.messages ? context.messages : []).filter(m => m.TicketResponseType != TicketResponseType.Note).map((item, index) => {
              return <ConversationMessage
                        keyValue={item.Id.toString()} 
                        sender={item.MessageSenderType} 
                        message={item.MessageText} 
                        attachment={item.Attachment} 
                        assistantIconUrl={`${context.webChatSettings.AssistantIconUrl}`} />
            })}

            {
              context.isThinking && 
              <ConversationMessage 
                keyValue="thinking-item" 
                sender={TicketResponseMessageSender.System} 
                assistantIconUrl={`${context.webChatSettings.AssistantIconUrl}`}
                message="Thinking..." />
            }
            
            
            {context.webChatDto.Status == WebChatStatus.Active && context.webChatDto.Ticket 
            && (context.webChatDto.Ticket.Status == TicketStatus.Resolved || context.webChatDto.Ticket.Status == TicketStatus.Closed)
              && closureButtons}

            {/*{context.webChatDto.Ticket */}
            {/*  && (context.webChatDto.Ticket.Status == TicketStatus.Resolved || context.webChatDto.Ticket.Status == TicketStatus.Closed)*/}
            {/*  &&  context.webChatDto.SurveyMessage*/}
            {/*    && surveyLink}*/}

            <div ref={setLastElementRef}></div>
          </div>
        </div>
        <div style={{ border: "2px solid transparent" }}>
        </div>
      </div>
    </div>
  )
}